<template>
  <div>
    <a-card size="small" title="模板管理">
        <a-button slot="extra" type="primary" @click="handleNew">新增</a-button>


        <searchE @handleSearch="handleSubmit"></searchE>

        <tableE ref="cpuTableID" :platForms="platforms"></tableE>
    </a-card>

     
  </div>
</template>
<script>

import searchE from './search'
import tableE from './table'
export default {
    data() {
        return {
            searchP:{},
            platforms:[],
            isShow:false,
            confirmLoading:false,
            domain:'001',
        };
    },
    methods: {
        handleSubmit(searchP){
            this.$refs.cpuTableID.handleSearch(searchP);
        },
        handleNew(){
            this.$router.push({
                path: "addtemplatmanager",
                query: {id:''}
            });
        },
       
    },
    components:{
        searchE,
        tableE
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
